const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!REACT_APP_BACKEND_URL && process.env.NODE_ENV === 'production') {
  throw new Error(
    'FATAL: REACT_APP_BACKEND_URL is not set. ' +
    'The frontend cannot reach the backend API. ' +
    'Pass --build-arg REACT_APP_BACKEND_URL=<url> during docker build.'
  );
}

export const API_BASE_URL = REACT_APP_BACKEND_URL || 'http://localhost:8000';
